import useHttp from '../hooks/useHttp';
import { useStore } from './useStore';

const useClearOrder = () => {
  const [state, dispatch] = useStore();
  const { sendRequest } = useHttp();

  const clearOrder = () => {
    console.log('clear');
    hideTimer();
    dispatch('SET', {
      dateTimeConfirmed: false,
      selectedDate: null,
      selectedDateTime: null,
      selectedTime: null,
      giftAddon: null,
      giftAddonName: null,
      giftWinter: false,
      giftAddon: null,
      giftAddonName: null
    });
    sendRequest({
      url: '/wp-json/wbst-booking/v1/ccs', 
      method: 'GET'
    }, false);
  }

  const hideTimer = () => {
    // console.log('hideTimer');
    document.body.classList.remove("has-timer");
    dispatch('SET', { timerActive: false });
  }

  return {
    clearOrder
  };
}

export default useClearOrder;